<template>
  <v-select
    solo
    :items="itemsShow"
    item-text="displayName"
    item-value="mode"
    v-model="mode"
    hide-details
    class="ma-0 pa-0"
    hint="Selecciona el tipo de geometría"
  >
    <template
      slot="selection"
      slot-scope="{ item, selected }"
    >
      <v-chip
        color="green"
        class="white--text"
        :selected="selected"
      >
        <vector-point-icon v-if="item.mode == 'Punto'" style="font-size: 17px;" class="mr-2"></vector-point-icon>
        <vector-polygon-icon v-if="item.mode == 'Poligono'" style="font-size: 17px;" class="mr-2"></vector-polygon-icon>
        <vector-rectangle-icon v-if="item.mode == 'Rectangulo'" style="font-size: 17px;" class="mr-2"></vector-rectangle-icon>
        <span v-text="item.displayName"></span>
      </v-chip>
    </template>
    <template
      slot="item"
      slot-scope="{ item, tile }"
    >
      <v-list-tile-avatar
        :size="25"
        color="green"
        class="headline font-weight-light white--text"
      >
        {{ item.displayName.charAt(0) }}
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-text="item.displayName"></v-list-tile-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <vector-point-icon v-if="item.mode == 'Punto'" style="font-size: 24px;"></vector-point-icon>
        <vector-polygon-icon v-if="item.mode == 'Poligono'" style="font-size: 24px;"></vector-polygon-icon>
        <vector-rectangle-icon v-if="item.mode == 'Rectangulo'" style="font-size: 24px;"></vector-rectangle-icon>
      </v-list-tile-action>
    </template>
  </v-select>
</template>

<script>
const drawProps = ['punto', 'poligono', 'rectangulo']
export default {
  props: ['defaultMode', ...drawProps],
  data() {
    return {
      mode: null,
      fab: false,
      items: ['Punto', 'Poligono', 'Rectangulo'],
      mappings: {
        punto: 'Point',
        poligono: 'Polygon',
        rectangulo: 'Circle'
      }
    }
  },

  created() {
    const validProps = drawProps.filter(prop => this[prop] !== undefined)
    const validPropsSet = new Set(validProps)
    const validItems = this.items.filter(item => validPropsSet.has(item.toLowerCase()))
    this.items = validItems
    this.$nextTick(() => this.mode = this.itemsShow[0].mode)
  },

  computed: {
    itemsShow() {
      return this.items.map(mode => ({
        mode,
        displayName: this.$t(mode.toLowerCase())
      }))
    }
  },

  watch: {
    mode() {
      this.$emit('change-draw-mode', this.mappings[this.mode.toLowerCase()])
    }
  }
}
</script>


<style>
  .v-text-field__details {
    margin: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// select-draw-mode.vue?747925aa